import { Pipe, PipeTransform } from '@angular/core';
import { BundleType } from '../models';

@Pipe({
    name: 'entityBundleIcon',
    standalone: false
})
export class EntityBundleIconPipe implements PipeTransform {

  public transform(value: BundleType): string {
    switch (value) {
      case BundleType.QUIZ:
        return 'game-controller';
      case BundleType.WEBINAR:
        return 'monitor-play';
      case BundleType.LIBRARY:
        return 'books';
      case BundleType.CONTENT_GROUP:
        return 'folders';
      case BundleType.LESSON:
      default:
        return 'book-open-text';
    }
  }

}
